import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable, catchError } from 'rxjs';
import { handleError } from '../tools/tools';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private cookie: CookieService, private router: Router) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    try {
      //! Get the token from the cookies
      const token = this.cookie.getAll()['x-token'];

      let req = request;

      if (token) {
        //! If the token exist, then we clone it
        req = request.clone({
          setHeaders: {
            //? Send to the headers in all request
            authorization: `Bearer ${token}`,
          },
        });
      }
      //! And send to the server
      return next.handle(req).pipe(
        catchError((error: HttpErrorResponse) => {
          //? If the server return 401 (unauthorized), return to login page
          if (error.status === 401) {
            this.router.navigate(['login']);
          }
          return handleError(error);
        })
      );
    } catch (error) {
      console.error('Error in JwtInterceptor:', error);
      return handleError(error);
    }
  }
}
